<template>
  <div
    v-if="libelle && libelle != ''"
    @click="push"
    :class="
      (canTruncate
        ? 'max-w-max hover:w-max hover:z-10 hover:relative'
        : 'w-max') +
        ' ' +
        (scaleOnHover
          ? 'transform hover:scale-105 transition duration-200'
          : '') +
        ' z-0 flex items-center border rounded-large px-3 py-1.5 ' +
        textFont +
        ' ' +
        textSize +
        ' ' +
        templateColor.background +
        ' ' +
        templateColor.text +
        ' ' +
        templateColor.border
    "
  >
    <div
      class="md:inline-block"
      :class="{
        truncate: canTruncate,
        hidden: responsive,
        'inline-block': !responsive,
      }"
    >
      {{ libelle ? libelle : '' }}
    </div>
    <div
      v-show="responsive"
      class="md:hidden"
    >
      {{ ((libelle || '').match(/\b(\w)/g) || []).join(' ').toUpperCase() }}
    </div>
    <div
      v-if="icon != ''"
      :class="'flex items-center ml-3 ' + iconSize"
    >
      <icon
        :name="icon"
        :class="iconColor"
      />
    </div>
    <div
      class="ml-4 cursor-pointer"
      v-if="isCloseable"
      @click="$emit('close')"
    >
      <icon name="close" />
    </div>
  </div>
</template>

<script>
import Icon from './Icon';
export default {
  components: { Icon },
  props: {
    libelle: {
      type: String,
      required: false,
      default: '',
    },

    themeColor: {
      type: String,
      required: false,
      default: 'default',
    },

    isCloseable: {
      type: Boolean,
      required: false,
      default: false,
    },

    textFont: {
      type: String,
      required: false,
      default: 'font-normal',
    },

    textSize: {
      type: String,
      required: false,
      default: 'text-base',
    },

    icon: {
      type: String,
      required: false,
      default: '',
    },

    iconColor: {
      type: String,
      required: false,
      default: 'text-gray-900',
    },

    iconSize: {
      type: String,
      required: false,
      default: '',
    },

    canTruncate: {
      type: Boolean,
      required: false,
      default: false,
    },

    scaleOnHover: {
      type: Boolean,
      required: false,
      default: false,
    },

    responsive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    templateColor() {
      let templateColor = {
        background: 'bg-white',
        text: 'text-gray-900',
        border: 'border-gray-900 border-opacity-25',
      };

      switch (this.themeColor) {
      case 'pink':
        templateColor = {
          background: 'bg-pink-100',
          text: 'text-pink-600',
          border: 'border-pink-600 border-opacity-25',
        };
        return templateColor;
      case 'indigo':
        templateColor = {
          background: 'bg-indigo-200',
          text: 'text-indigo-600',
          border: 'border-indigo-600 border-opacity-25',
        };
        return templateColor;
      case 'orange':
        templateColor = {
          background: 'bg-orange-100',
          text: 'text-orange-600',
          border: 'border-orange-600 border-opacity-25',
        };
        return templateColor;
      case 'teal':
        templateColor = {
          background: 'bg-teal-300',
          text: 'text-teal-600',
          border: 'border-teal-600 border-opacity-25',
        };
        return templateColor;
      case 'white':
        templateColor = {
          background: 'bg-white',
          text: 'text-gray-900',
          border: 'border-gray-600',
        };
        return templateColor;
      case 'indigo-2':
        templateColor = {
          background: 'bg-indigo-200',
          text: 'text-indigo-600',
          border: 'border-indigo-600',
        };
        return templateColor;

      default:
        return templateColor;
      }
    },
  },

  methods: {
    push() {
      this.$emit('push');
    },
  },
};
</script>
